import TooltipNavigation from './TooltipNavigation';

export default TooltipNavigation;
